import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { routes } from './routes';
import { NoticesProvider } from './ui';
import './styles/fonts';
import './styles/app.css';

// ⚠ **Coming back to the tab refetches.** This said queries were invalidated
// by server-sent events rather than polling, which described a mechanism that
// was never built — so with the focus refetch off as well, an open page showed
// whatever it had loaded, for ever. A bot that joined, a note that finished, a
// meeting somebody turned off: none of it arrived until a reload, and on
// 2026-09-22 that cost Vladimir four fixes he could not see and reported as
// broken. `useFreshBuild` covers the other half — a page whose *code* is old.
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: true } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <NoticesProvider>
        <RouterProvider router={createBrowserRouter(routes)} />
      </NoticesProvider>
    </QueryClientProvider>
  </StrictMode>,
);
